import { map, first } from 'rxjs/operators';
import rfdc from 'rfdc';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { UnitMeasurement } from '../../../assets/data/enum/unit_measurement.enum';
import { environment } from '../../../environments/environment';
import { User } from '../_models';
import { StableActivity } from '../_models/stableActivity';
import { UserService } from './user.service';
import { StableActivityGrouped } from '../_models/stableActivityGrouped';

@Injectable()
export class StableActivityService {
  // Services
  private http = inject(HttpClient);
  private userService = inject(UserService);
  private clone = rfdc();

  ItemObj: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private apiBaseUrl = environment.apiBaseUrl;
  private unitMeasurement = UnitMeasurement;
  stableActivityList: Observable<StableActivity[]>;
  fieldActivityGroupedList$: Observable<StableActivityGrouped[]>;
  selectActivitiesTab$: BehaviorSubject<string> = new BehaviorSubject<string>('grouped');
  resultList$: BehaviorSubject<Array<StableActivity>> = new BehaviorSubject<Array<StableActivity>>(
    []
  );
  originalFieldActivityList$: BehaviorSubject<Array<StableActivity>> = new BehaviorSubject<
    Array<StableActivity>
  >([]);
  showLoaderFieldActivityGrouped$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  currentUser: User = new User();
  allStableActivity$: BehaviorSubject<Array<StableActivity>> = new BehaviorSubject<
    Array<StableActivity>
  >([]);
  allStableActivityGrouped$: BehaviorSubject<Array<StableActivityGrouped>> = new BehaviorSubject<
    Array<StableActivityGrouped>
  >([]);
  fieldActivitiesCustomType$: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);

  constructor() {
    this.userService.getUserMeFromLocalStore().subscribe((u: User) => {
      this.currentUser = u;
    });
  }

  initActivitiesTab() {
    this.selectActivitiesTab$ = new BehaviorSubject<any>('grouped');
  }

  setActivitiesTab(tab) {
    this.selectActivitiesTab$.next(tab);
  }

  getActivitiesTab() {
    return this.selectActivitiesTab$.asObservable();
  }

  getStableActivities(): Observable<StableActivity[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/stableActivities').pipe(
      map((response) => {
        if (response) {
          if (response) {
            this.allStableActivity$.next(response);
            return response;
          }
        }
      })
    );
  }

  getStableActivity(id: number): Observable<StableActivity> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/stableActivities/' + id)
      .pipe(map((response) => response));
  }

  saveStableActivity(stableActivityItem): Observable<StableActivity> {
    const stableActivity = { ...stableActivityItem };
    delete stableActivity.lastUpdated;
    delete stableActivity.dateCreated;
    delete stableActivity.cropObj;

    if (stableActivity.mixes) {
      const arrmixes: Array<any> = [];
      stableActivity.mixes.forEach((element) => {
        if (element.product) {
          const idproduct: any = {
            id: element.product.id,
          };
          element.product = idproduct;
        }
        arrmixes.push(element);
      });
      stableActivity.mixes = arrmixes;
    }
    if (stableActivity.equipments) {
      const arrequipments: Array<any> = [];
      stableActivity.equipments.forEach((element) => {
        const idequipment: any = {
          id: element.id,
        };
        arrequipments.push(idequipment);
      });
      stableActivity.equipments = arrequipments;
    }
    if (stableActivity.users) {
      const arrusers: Array<any> = [];
      stableActivity.users.forEach((element) => {
        const iduser: any = {
          id: element.id,
        };
        arrusers.push(iduser);
      });
      stableActivity.users = arrusers;
    }

    if (stableActivity.stable) {
      const idStable: any = {
        id: stableActivity.stable.id,
      };
      stableActivity.field = idStable;
    }
    delete stableActivity.verificationDate;
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    stableActivity.companyId = companySelected ? companySelected.id : null;

    if (stableActivity.id) {
      return this.http
        .put<StableActivity>(
          this.apiBaseUrl + 'api/private/v1/stableActivities/' + stableActivity.id,
          stableActivity
        )
        .pipe(
          map((response) => {
            if (response) {
              return response;
            }
          })
        );
    } else {
      return this.http
        .post<StableActivity>(this.apiBaseUrl + 'api/private/v1/stableActivities/', stableActivity)
        .pipe(
          map((response) => {
            if (response) {
              return response;
            }
          })
        );
    }
  }

  deleteStableActivity(stableActivity: StableActivity): Observable<StableActivity> {
    return this.http
      .delete(this.apiBaseUrl + 'api/private/v1/stableActivities/' + stableActivity.id)
      .pipe(
        map((response) => {
          if (response) {
            return { id: stableActivity.id } as StableActivity;
          }
        })
      );
  }

  getLocalStablectivityById = (id: number): StableActivity => {
    let item: StableActivity;
    this.allStableActivity$
      .pipe(first((list: StableActivity[]) => list && list.length > 0))
      .subscribe((list: StableActivity[]) => {
        item = list.find((i) => i.id === id);
      });
    return item;
  };

  getLocalStableActivityByUUID = (uuid): Array<StableActivity> => {
    let fasList: Array<StableActivity> = [];
    if (uuid) {
      this.allStableActivity$.subscribe((fas) => {
        fasList = _.filter(
          fas,
          function (f) {
            return f.uuid === uuid;
          }.bind(this)
        );
      });
      return fasList;
    } else {
      return fasList;
    }
  };

  getUnitMeasurementConfiguration() {
    return [this.unitMeasurement.KG_HA, this.unitMeasurement.L_HA, this.unitMeasurement.UNIT];
  }

  getUnitMeasurementConfigurationLivestock() {
    return [
      this.unitMeasurement.kg_animal,
      // this.unitMeasurement.g_animal, // more info in XFARMDEV-4704
      // this.unitMeasurement.mg_animal, // more info in XFARMDEV-4704
      this.unitMeasurement.l_animal,
      this.unitMeasurement.unit_animal,
    ];
  }

  getMetoBlueStatus = () => {
    return [
      'clear',
      'cloudy',
      'changeable',
      'very_cloudy',
      'overcast',
      'foggy',
      'overcast_with_rain',
      'changeable_with_rain_showers',
      'thunderstorm',
      'overcast_with_snow',
      'changeable_with_snow_showers',
      'rainfall_mixed_with_snow',
    ];
  };

  checkIfContainerIdExistInStableActivity(containerId: number): Array<any> {
    const tmpActivity = [];
    this.allStableActivity$.subscribe((activities) => {
      activities.forEach((activity) => {
        if (activity && activity.mixes && activity.mixes.length > 0) {
          activity.mixes.forEach((mix) => {
            if (mix && mix.container && mix.container.id && mix.container.id === containerId) {
              tmpActivity.push(activity);
            }
          });
        }
      });
    });

    return tmpActivity;
  }

  getStableActivityGrouped(): Observable<StableActivityGrouped[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/stableActivityGrouped').pipe(
      map((response) => {
        if (response) {
          if (response) {
            this.allStableActivityGrouped$.next(response);
            return response;
          }
        }
      })
    );
  }

  getFieldActivityGroupedByUUID(uuid): Observable<StableActivityGrouped> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/stableActivityGrouped/' + uuid)
      .pipe(
        map((response) => {
          if (response) {
            if (response) {
              return response;
            }
          }
        })
      );
  }

  checkIfStableBoxExistInStableActivity(idStableBox: number): Observable<any> {
    if (idStableBox) {
      return this.allStableActivity$.pipe(
        map((stableActivityList: StableActivity[]) =>
          stableActivityList.filter((f) => f.stableBox && f.stableBox.id === idStableBox)
        )
      );
    }
  }

  getActivityForClone(stableActivity: StableActivity): StableActivity {
    const sAToBeCloned: StableActivity = this.clone(stableActivity);
    delete sAToBeCloned.id;
    delete sAToBeCloned.uuid;
    if (sAToBeCloned.mixes && sAToBeCloned.mixes.length > 0) {
      sAToBeCloned.mixes = sAToBeCloned.mixes.map((mix) => {
        delete mix.stableActivity;
        delete mix.uuid;
        return mix;
      });
    }
    return sAToBeCloned;
  }

  getStableActivityGroupedForClone(SAGrouped: StableActivityGrouped) {
    delete SAGrouped.uuid;
    delete SAGrouped.id;
    return SAGrouped;
  }

  getExportType() {
    const result: Array<any> = [
      {
        type: 'StableActivities',
        subtype: 'CompleteStableActivityListToLocalExport',
        formats: [
          {
            type: 'csv',
            enabled: true,
            compression: false,
            col: '6',
          },
          {
            type: 'xls',
            enabled: true,
            compression: false,
            col: '6',
          },
        ],
      },
    ];
    return result;
  }

  checkIfAnimalIdExistInStableActivity(animalId: number): Array<any> {
    const tmpActivity = [];
    this.allStableActivity$.subscribe((activities) => {
      activities.forEach((activity) => {
        if (activity && activity.animals && activity.animals.length > 0) {
          activity.animals.forEach((a) => {
            if (a && a.id && a.id === animalId) {
              tmpActivity.push(activity);
            }
          });
        }
      });
    });

    return tmpActivity;
  }

  getLocalStableActivityDone = (): Array<StableActivityGrouped> => {
    let sasList: Array<StableActivityGrouped>;
    this.allStableActivityGrouped$.subscribe((fas) => {
      sasList = _.filter(
        fas,
        function (f) {
          return f.done === true || f.done === null || f.done === undefined;
        }.bind(this)
      );
    });
    return sasList;
  };

  retrievLastDoneStableActivityFromStable(stable, year: any): StableActivity {
    const filteredLocalStableActivityDone = this.getLocalStableActivityDone().filter((item) =>
      item.stableIds.includes(stable.id)
    );
    if (filteredLocalStableActivityDone && filteredLocalStableActivityDone.length > 0) {
      // If there is at least one activity with the searched ID, return the last one based on the creation date.
      const lastFieldActivity = filteredLocalStableActivityDone.reduce((prev, current) =>
        new Date(prev.activityDate + '') > new Date(current.activityDate + '') ? prev : current
      );
      return this.getLocalStablectivityById(lastFieldActivity.ids[0]);
    }

    return null;
  }
}
